import { Stack, styled } from '@mui/material'
import Calendar from 'assets/icons/nucleo/18px_calendar.svg'
import Itinerary from 'assets/icons/nucleo/18px_itinerary-2.svg'
import {
  CardContainer as EventCardContainer,
  InstantBadge as EventInstantBadge
} from 'components/EventCard.style'
import { NewFlexContainer } from 'components/common/common.style'
import { Type as RaceCardType } from 'components/event/RaceCard/RaceCard.style'

export const MobilePopupContent = styled(Stack)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 55%;
  min-width: 370px;
  z-index: 1000;
  border-radius: 24px;
  overflow: hidden;
  background-color: white;
`

export const CardContainer = styled(EventCardContainer)`
  flex-direction: row;
  max-width: 370px;
`

export const ImageContainer = styled(NewFlexContainer)`
  position: relative;
  min-width: 140px;
  min-height: 107px;
`

export const InstantBadgeContainer = styled(NewFlexContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 6px;
  position: absolute;
  z-index: 1;
`

export const InstantBadge = styled(EventInstantBadge)`
  font-size: 12px;
  padding: 1px 6px;
`

export const CalendarIcon = styled(Calendar)`
  min-width: 18px;
`

export const ItineraryIcon = styled(Itinerary)`
  min-width: 18px;
`

export const Type = styled(RaceCardType)`
  font-size: 12px;
  line-height: 16px;
`
